module.exports = __webpack_public_path__ + "assets/img/contact.0e7cb0fa.jpg";